import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Xing = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 4C26.76 4 26.54 4.085 26.368 4.225L14.742 13.737L17.953 3.303C17.983 3.207 18 3.106 18 3C18 2.448 17.552 2 17 2C16.549 2 16.168 2.299 16.043 2.709L12.533 14.118L9.77002 10.363C9.77002 10.363 9.77002 10.363 9.76902 10.362C9.58602 10.141 9.30902 10 8.99902 10C8.44702 10 7.99902 10.448 7.99902 11C7.99902 11.242 8.08502 11.464 8.22802 11.637L10.993 15.395L4.89902 16.004C4.39402 16.054 3.99902 16.48 3.99902 16.999C3.99902 17.551 4.44702 17.999 4.99902 17.999C5.03302 17.999 5.06602 17.997 5.09802 17.994L10.155 17.488L4.36502 22.225C4.14202 22.408 3.99902 22.687 3.99902 22.998C3.99902 23.55 4.44702 23.998 4.99902 23.998C5.23902 23.998 5.45902 23.913 5.63202 23.772L10.883 19.476L8.04602 28.695C8.01602 28.791 7.99902 28.892 7.99902 28.998C7.99902 29.55 8.44702 29.998 8.99902 29.998C9.25102 29.998 9.48102 29.904 9.65702 29.75C9.65702 29.75 25.663 15.745 25.665 15.743C25.87 15.56 25.999 15.295 25.999 14.998C25.999 14.446 25.551 13.998 24.999 13.998C24.965 13.998 24.932 14 24.9 14.003L16.552 14.838L27.633 5.772C27.857 5.589 27.999 5.31 27.999 4.999C27.999 4.447 27.551 3.999 26.999 3.999L27 4ZM21.989 16.306L10.991 25.929L13.75 17.125L21.989 16.306V16.306Z" />
	</svg>
);

export default Xing;
